<template>
  <div class="pharmacyFinder">
    <div class="pharmacyFinder-search">
      <van-search
        v-model="value"
        placeholder="请输入省份、城市、区县搜索"
        readonly
        @focus="areaShow = true"
      />
    </div>
    <div class="pharmacyFinder-list">
      <div
        v-for="item in storeList"
        :key="item.id"
        class="pharmacyFinder-item"
        @click="goDrug(item)"
      >
        <div class="pharmacyFinder-item-left">
          <div
            class="pharmacyFinder-item-radio"
            @click.stop="currentSelect = item"
          >
            <van-radio-group :value="currentSelect.id">
              <van-radio :name="item.id"></van-radio>
            </van-radio-group>
          </div>
          <div class="pharmacyFinder-item-content">
            <div class="pharmacyFinder-item-title">
              {{ item.name }} <strong v-if="item.channel_type">（双通道）</strong>
            </div>
            <div class="pharmacyFinder-item-option-box">
              <div class="pharmacyFinder-item-option">
                地址：{{ item.address }}
              </div>
              <div class="pharmacyFinder-item-option">
                联系人：{{ item.contact }}
              </div>
              <div class="pharmacyFinder-item-option">
                电话：{{ item.mobile }}
              </div>
              <template v-if="drugInfo[item.id]">
                <div class="pharmacyFinder-item-option">
                  药品规格：{{ drugInfo[item.id].specs }}
                </div>
                <div class="pharmacyFinder-item-option">
                  药品单价：{{ drugInfo[item.id].price_tag }}
                </div>
              </template>

            </div>
          </div>

        </div>
        <div class="pharmacyFinder-item-right">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="pharmacyFinder-btn">
      <el-button
        v-if="!query.maintain"
        type="primary"
        @click="nextStep"
      >下一步</el-button>
    </div>

    <van-popup
      v-model="areaShow"
      position="bottom"
      :style="{ height: '308px' }"
    >
      <van-area
        title="标题"
        :area-list="areaList"
        value="110101"
        @confirm="areaConfirm"
        @cancel="areaShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import pd1Service from "@/apis/pd1/index.js";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";
import { Message } from "element-ui";

export default {
  data() {
    return {
      radio: "",
      areaShow: false,
      value: "",
      searchForm: {},
      storeList: [],
      drugInfo: {},
      areaList,
      currentSelect: {},
      query: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    const drugInfo = getStorageExpire(CONFIG_STORAGE.PD1_DRUG);

    if (from.name === "Pd1Drug" && drugInfo?.id) {
      localStorage.removeItem(CONFIG_STORAGE.PD1_DRUG);
      next((vm) => {
        vm.drugInfo[drugInfo.drugstore_id] = drugInfo;
        vm.query = vm.$route.query;

        vm.$forceUpdate();
      });
    } else {
      next((vm) => {
        vm.query = vm.$route.query;

        vm.$forceUpdate();
      });
    }
    console.log(from);

    next();
  },
  created() {
    this.query = this.$route.query;
    this.drugstoreList();
  },
  methods: {
    drugstoreList() {
      const { searchForm } = this;
      if (searchForm.area) {
        searchForm.province = searchForm.area[0].name;
        searchForm.city = searchForm.area[1].name;
        searchForm.county = searchForm.area[2].name;
      }
      const params = {
        ...searchForm,
      };
      pd1Service.drugstoreList(params).then((res) => {
        this.storeList = res.data;
      });
    },
    nextStep() {
      const { currentSelect } = this;
      const storeInfo = {
        ...currentSelect,
        drugInfo: this.drugInfo[currentSelect.id],
      };
      let errMsg = "";
      if (!storeInfo.id) {
        errMsg = "请选择药店";
      } else if (!storeInfo.drugInfo) {
        errMsg = "请选择药品信息";
      }
      if (errMsg) {
        Message({
          message: errMsg,
          type: "error",
        });
        return;
      }
      setStorageExpire(CONFIG_STORAGE.PD1_STORE, storeInfo, 60 * 24);
      this.$router.push({
        name: "Pd1PayConfirm",
        query: {
          ...this.$route.query,
        },
      });
    },
    goDrug(item) {
      this.currentSelect = item;
      this.$router.push({
        name: "Pd1Drug",
        query: {
          id: item.id,
        },
      });
    },
    areaConfirm(value) {
      this.searchForm.area = value;
      this.drugstoreList();
      this.areaShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pharmacyFinder {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pharmacyFinder-list {
  padding: 10px 0;
  flex: 1;
  overflow-y: scroll;
}
.pharmacyFinder-item {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 10px;
  .pharmacyFinder-item-left {
    display: flex;
    align-items: center;
  }
  .pharmacyFinder-item-radio {
    margin-right: 10px;
  }
  .pharmacyFinder-item-title {
    font-size: 16px;
    font-weight: 900;
    color: #333;
    margin-bottom: 5px;
    strong {
      color: blue;
    }
  }
}
.pharmacyFinder-btn {
  padding: 20px 15px;
  .el-button {
    width: 100%;
  }
}
</style>